import { render, staticRenderFns } from "./VetNotes.vue?vue&type=template&id=b0a7fd66&"
import script from "./VetNotes.vue?vue&type=script&lang=js&"
export * from "./VetNotes.vue?vue&type=script&lang=js&"
import style0 from "./VetNotes.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports